import React, { useState, useEffect } from 'react'
import { TbFileUpload } from 'react-icons/tb'
import { FaUserPen } from 'react-icons/fa6'
import { MdOutlinePhone, MdOutlineAttachEmail } from 'react-icons/md'
import { AiOutlineIdcard } from 'react-icons/ai'
import { ImCreditCard } from 'react-icons/im'
import { FiDollarSign } from 'react-icons/fi'
import { FaRegBuilding } from 'react-icons/fa'
import { MdOutlineDeleteForever } from 'react-icons/md'
import * as api from '../../utils/api/apiClient'
import { toast } from 'react-toastify'

const EmployeeEditForm = ({ data, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    work_id: '',
    post: '',
    phone_number: '',
    aadhar: '',
    pan_number: '',
    address: '',
    bank_name: '',
    ifsc_code: '',
    account_number: '',
    salary: '',
    email: '',
    da_percentage: '',
    uan_number: '',
  })

  console.log(data)
  const [formImage, setFormImage] = useState({
    profile_pic: null,
    preview: data?.profile_pic || '', // Initialize with existing profile pic
  })

  const [errors, setErrors] = useState({})

  // Effect to populate form with existing data when component mounts
  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || '',
        work_id: data.work_id || '',
        post: data.post || '',
        phone_number: data.phone_number || '',
        aadhar: data.aadhar || '',
        pan_number: data.pan_number || '',
        address: data.address || '',
        bank_name: data.bank_name || '',
        ifsc_code: data.ifsc_code || '',
        account_number: data.account_number || '',
        salary: data.salary || '',
        email: data.email || '',
        da_percentage: data.da_percentage || '',
        uan_number: data.uan_number || '',
      })
    }
  }, [data])

  const validateForm = () => {
    const newErrors = {}

    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      newErrors.email = 'Please enter a valid email address'
    }

    if (!formData.phone_number.match(/^\d{10}$/)) {
      newErrors.phone_number = 'Please enter a valid 10-digit phone number'
    }

    if (!formData.aadhar.match(/^\d{12}$/)) {
      newErrors.aadhar = 'Please enter a valid 12-digit Aadhar number'
    }

    if (!formData.pan_number.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
      newErrors.pan_number = 'Please enter a valid PAN number'
    }

    // Add salary validation
    if (!/^\d+$/.test(formData.salary)) {
      newErrors.salary = 'Please enter a valid salary amount (numbers only)'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      if (file.size > 5242880) {
        setErrors((prev) => ({
          ...prev,
          image: 'Image size should be less than 5MB',
        }))
        return
      }

      const reader = new FileReader()
      reader.onloadend = () => {
        setFormImage({
          profile_pic: file,
          preview: reader.result,
        })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    if (validateForm()) {
      const updatedData = {
        ...formData,
        profile_pic: formImage.profile_pic,
        id: data?.id,
        // Convert salary to integer
        salary: parseInt(formData.salary, 10),
        da_percentage: parseInt(formData.da_percentage, 10),
      }

      console.log()

      try {
        // Additional validation for salary
        if (isNaN(updatedData.salary)) {
          toast.error('Please enter a valid salary amount')
          return
        }

        const res = await api.updateEmployee(data.id, updatedData)
        console.log('', res.data)
        toast.success('Details Updated Successfully')
        onSuccess?.()
      } catch (error) {
        console.log(error)
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message)
        }
      }
    }
  }
  // *****************************image*************************************
  const handleImageSubmit = async (e) => {
    e.preventDefault()

    if (formImage.profile_pic) {
      const formData = new FormData() // Create a new FormData instance
      formData.append('profile_pic', formImage.profile_pic) // Append the file
      formData.append('id', data.id) // Append the employee ID (if required by the API)

      try {
        const res = await api.updateEmployeeImage(data.id, formData) // Use FormData for the API call
        toast.success('Profile Pic uploaded successfully')
        onSuccess?.()
      } catch (error) {
        console.log(error)
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message)
        }
      }
    }
  }
  const remove = async (e) => {
    e.preventDefault()

    try {
      const res = await api.deleteEmployeeImage(data.id) // Use FormData for the API call
      toast.success('Profile pic Removed successfully')
      onSuccess?.()
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }

  return (
    <div className='max-w-4xl mx-auto p-6 rounded-lg shadow-md bg-cream'>
      <div className='text-center mb-6'>
        <h2 className='text-2xl font-bold text-brown'>Employee Edit Form</h2>
      </div>

      {/* Profile Image Upload */}

      <form onSubmit={handleImageSubmit} className='mb-8'>
        <div className='flex flex-col items-center gap-4'>
          <div className='relative'>
            {/* Image or Placeholder */}
            {formImage.preview ? (
              <img
                src={formImage.preview}
                alt='Profile'
                className='w-32 h-32 rounded-full object-cover border-4 border-gold'
              />
            ) : (
              <div
                onClick={remove}
                className='w-32 h-32 rounded-full flex items-center justify-center border-4 border-gold bg-light_gray cursor-pointer'
              >
                <FaUserPen size={64} className='text-brown' />
              </div>
            )}

            {/* Delete Button */}
            {formImage.preview && (
              <button
                type='button'
                onClick={remove}
                className='absolute -bottom-3 right-9 bg-gold p-2 text-white rounded-full cursor-pointer hover:bg-rust transition-colors'
              >
                <MdOutlineDeleteForever size={20} />
              </button>
            )}

            {/* Upload Button */}
            <label
              htmlFor='imageUpload'
              className='absolute bottom-0 right-0 bg-gold p-2 rounded-full cursor-pointer hover:bg-rust transition-colors'
            >
              <TbFileUpload size={20} className='text-white' />
              <input
                type='file'
                id='imageUpload'
                accept='image/*'
                className='hidden'
                onChange={handleImageUpload}
              />
            </label>
          </div>

          {/* Error Message */}
          {errors.image && (
            <p className='text-red-500 text-sm'>{errors.image}</p>
          )}

          {/* Submit Button */}
          <button
            type='submit'
            className='px-6 py-2 rounded-lg font-bold text-white bg-gold hover:bg-rust transition duration-300'
            disabled={!formImage.profile_pic}
          >
            Update Profile Picture
          </button>
        </div>
      </form>

      {/* Main Form */}
      <form onSubmit={handleFormSubmit} className='space-y-6'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          {/* Personal Details */}
          <div className='space-y-4'>
            <h3 className='text-xl font-semibold text-brown'>
              Personal Details
            </h3>
            {[
              { name: 'name', label: 'Name', icon: FaUserPen },
              { name: 'email', label: 'Email', icon: MdOutlineAttachEmail },
              {
                name: 'phone_number',
                label: 'Phone Number',
                icon: MdOutlinePhone,
              },
            ].map((field) => (
              <div key={field.name}>
                <label className='block mb-2 font-semibold text-brown'>
                  {field.label}
                </label>
                <div className='flex items-center'>
                  <field.icon className='mr-2 text-brown' />
                  <input
                    type='text'
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleInputChange}
                    className='w-full p-2 border rounded border-light_gray bg-transparent'
                    required
                  />
                </div>
                {errors[field.name] && (
                  <p className='text-red-500 text-sm mt-1'>
                    {errors[field.name]}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Employment Details */}
          <div className='space-y-4'>
            <h3 className='text-xl font-semibold text-brown'>
              Employment Details
            </h3>
            {[
              {
                name: 'work_id',
                label: 'Employee ID',
                icon: AiOutlineIdcard,
              },
              { name: 'post', label: 'Level', icon: FaRegBuilding },
              {
                name: 'salary',
                label: 'Salary',
                icon: FiDollarSign,
                type: 'number', // Add type number for salary input
              },
              {
                name: 'da_percentage',
                label: 'DA Percentage',
                icon: FiDollarSign,
                type: 'number', // Add type number for salary input
              },
            ].map((field) => (
              <div key={field.name}>
                <label className='block mb-2 font-semibold text-brown'>
                  {field.label}
                </label>
                <div className='flex items-center'>
                  <field.icon className='mr-2 text-brown' />
                  <input
                    type={field.type || 'text'} // Use number type for salary
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleInputChange}
                    className='w-full p-2 border rounded border-light_gray bg-transparent'
                    required
                  />
                </div>
                {errors[field.name] && (
                  <p className='text-red-500 text-sm mt-1'>
                    {errors[field.name]}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Documents Section */}
        <div className='space-y-4'>
          <h3 className='text-xl font-semibold text-brown'>Document Details</h3>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            {[
              { name: 'aadhar', label: 'Aadhar Number', icon: AiOutlineIdcard },
              { name: 'pan_number', label: 'PAN Number', icon: ImCreditCard },
              {
                name: 'uan_number',
                label: 'UAN Number',
                icon: AiOutlineIdcard,
              },
            ].map((field) => (
              <div key={field.name}>
                <label className='block mb-2 font-semibold text-brown'>
                  {field.label}
                </label>
                <div className='flex items-center'>
                  <field.icon className='mr-2 text-brown' />
                  <input
                    type='text'
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleInputChange}
                    className='w-full p-2 border rounded border-light_gray bg-transparent'
                  />
                </div>
                {errors[field.name] && (
                  <p className='text-red-500 text-sm mt-1'>
                    {errors[field.name]}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bank Details */}
        <div className='space-y-4'>
          <h3 className='text-xl font-semibold text-brown'>Bank Details</h3>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            {[
              { name: 'bank_name', label: 'Bank Name', icon: FaRegBuilding },
              { name: 'ifsc_code', label: 'IFSC Code', icon: ImCreditCard },
              {
                name: 'account_number',
                label: 'Account Number',
                icon: ImCreditCard,
              },
            ].map((field) => (
              <div key={field.name}>
                <label className='block mb-2 font-semibold text-brown'>
                  {field.label}
                </label>
                <div className='flex items-center'>
                  <field.icon className='mr-2 text-brown' />
                  <input
                    type='text'
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleInputChange}
                    className='w-full p-2 border rounded border-light_gray bg-transparent'
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Address Section */}
        <div className='space-y-4'>
          <h3 className='text-xl font-semibold text-brown'>Address Details</h3>
          <textarea
            name='address'
            value={formData.address}
            onChange={handleInputChange}
            placeholder='Enter Address'
            className='w-full p-2 border rounded border-light_gray bg-transparent'
            rows={3}
          />
        </div>

        {/* Submit Button */}
        <div className='mt-8 flex justify-center'>
          <button
            type='submit'
            className='px-8 py-3 rounded-lg font-bold text-white bg-gold hover:bg-rust transition duration-300'
          >
            Update Employee Details
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmployeeEditForm
